import React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"

import "./bootstrap.css"

import "./aplikasikasirmini.css"
import "./mesinkasirdark.css"

const Home = ({ children }) => {
  return (
    <>
	<div className="col-12 shadow fixed-top bg-white">
<ul className="nav justify-content-center">
  <li className="nav-item">
    <Link className="nav-link" title="aplikasi mesin kasir online" to="/">Home</Link>
  </li>
  <li className="nav-item">
    <Link className="nav-link" title="aplikasi online" to="/webapp">Web App</Link>
  </li>  <li className="nav-item">
    <Link className="nav-link" title="mesin kasir" to="/buildapk">APK</Link>
  </li>
  <li className="nav-item">
    <Link className="nav-link" title="mesin kasir" to="/modernwebsite">Website</Link>
  </li>

</ul></div>

      <div
        className="container-fluid"
      >
	  
        <main>{children}</main>
        <div className="col-12 col-md-12 p-3 p-md-3">
        <Link className="text-white" to="/sourcecode">free download software source code pos →</Link>          
        </div>
        <div className="col-12 col-md-12 p-3 p-md-3 bg-light text-center lead">
<h3>Contact Us</h3>
<a href="https://wa.me/6285646104747" className="button border border-light">Chat Now</a>
<a href="tel:+6285331361404" className="button border border-light">Call Us</a>
<a href="mailto:hockeycorpmarketing@gmail.com" className="button border border-light">Email</a>
         <footer className="lead text-center"><small>
          © {new Date().getFullYear()}, <a href="/" title="mesin kasir online">mesinkasironline</a> <br/> Built with
          {` `}
          <a href="https://www.gatsbyjs.org" target="blank">Gatsby</a> develope by  <a href="https://gatsbyart.web.app" target="blank">GatsbyArt</a> Powered by  <a href="https://firebase.google.com/" target="blank">Firebase</a> </small>

        </footer>
      </div>
      </div>
    </>
  )
}

Home.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Home